<template>
  <div class="modal">
    <div class="modal-content">
      <div class="close-wrapper">
        <span class="close" v-on:click="$emit('close')">
          <div class="bar-1"></div>
          <div class="bar-2"></div>
        </span>
      </div>
      <h1 class="register-title-primary">Registracija</h1>
      <form id="registration" v-on:submit.prevent="register()" novalidate="true">
        <div class="form-field">
          <input id="firstname" type="text" v-model="userToRegister.firstName" v-on:change="validateFirstName" />
          <label for="firstname" v-bind:class="userToRegister.firstName ? 'field-filled' : ''">Ime*</label>
          <div class="error" v-bind:style="{ visibility: isFirstNameValid ? 'hidden' : 'visible' }">
            Ime ne smije biti prazno.
          </div>
        </div>
        <div class="form-field">
          <input id="lastname" type="text" v-model="userToRegister.lastName" v-on:change="validateLastName" />
          <label for="lastname" v-bind:class="userToRegister.lastName ? 'field-filled' : ''">Prezime*</label>
          <div class="error" v-bind:style="{ visibility: isLastNameValid ? 'hidden' : 'visible' }">
            Prezime ne smije biti prazno.
          </div>
        </div>
        <div class="form-field">
          <input
            id="email"
            type="text"
            v-bind:style="{ 'border-bottom': doesEmailExist || !isEmailValid ? '1.5px solid #ef5b5b' : '' }"
            v-model="userToRegister.email"
            v-on:change="checkIfEmailExists()"
          />
          <label for="email" v-bind:class="userToRegister.email ? 'field-filled' : ''">Email*</label>
          <div class="error" v-bind:style="{ visibility: doesEmailExist || !isEmailValid ? 'visible' : 'hidden' }">
            {{ doesEmailExist ? 'Upisana e-mail adresa već postoji.' : 'Upisana e-mail adresa nije valjana.' }}
          </div>
        </div>
        <div class="form-field form-field--pointer">
          <img class="arrow-down" src="../../assets/icons/arrow-down-select.svg" alt="arrow-down" />
          <select id="birthyear" v-model="userToRegister.birthYear">
            <option v-bind:value="null">-</option>
            <option v-for="year in getYears()" v-bind:value="year" v-bind:key="year">{{ year }}</option>
          </select>
          <label for="birthyear" class="field">Godina rođenja</label>
        </div>
        <div class="form-field">
          <input
            id="password"
            type="password"
            v-model="userToRegister.password"
            v-bind:style="{ 'border-bottom': isPasswordValid ? '' : '1.5px solid #ef5b5b' }"
            v-on:change="validatePassword"
          />
          <label for="password" v-bind:class="userToRegister.password ? 'field-filled' : ''">Lozinka*</label>
          <div class="error" v-bind:style="{ display: isPasswordValid ? 'none' : 'block' }">
            Lozinka nije valjana. Mora imati bar 8 znakova, jedno veliko slovo i jedan broj.
          </div>
        </div>
        <div class="form-field">
          <input
            id="repeatedpassword"
            type="password"
            v-model="repeatedPassword"
            v-bind:style="{ 'border-bottom': isRepeatedPasswordValid ? '' : '1.5px solid #ef5b5b' }"
            v-on:change="validateRepeatedPassword"
          />
          <label for="repeatedpassword" v-bind:class="repeatedPassword ? 'field-filled' : ''">Ponovi lozinku*</label>
          <div class="error" v-bind:style="{ visibility: isRepeatedPasswordValid ? 'hidden' : 'visible' }">
            Upisane lozinke se ne poklapaju.
          </div>
        </div>
        <div class="form-end">
          <div class="checkbox">
            <input type="checkbox" id="newsletterCheckbox" v-model="userToRegister.newsletterEnabled" />
            <label for="newsletterCheckbox">
              Rado bismo s tobom dijelili sve najvažnije informacije o konferenciji da budeš u toku. Nećemo te spammat,
              obećavamo!
            </label>
          </div>
          <div class="checkbox">
            <input type="checkbox" id="gdprCheckbox" v-model="acceptedGdpr" />
            <label for="gdprCheckbox"
              >Slažem se s&nbsp;<span class="terms" v-on:click="showGdprModal = true"
                >uvjetima i odredbama.</span
              ></label
            >
          </div>
          <button type="submit" class="button" value="submit">Registriraj se</button>
          <div
            class="error"
            v-bind:style="{ display: (isFormValid() || !isRegistering) && !isSubmitted ? 'none' : 'block' }"
          >
            Registracija nije uspjela. Potrebno je unijeti ispravne podatke.
          </div>
          <div class="error" v-if="!didRegistrationSucceed && isRegistrationOver">
            Registracija nije uspjela. Molimo Vas provjerite unesene podatke još jednom.
          </div>
          <div class="success spacer-top" v-else-if="didRegistrationSucceed && isRegistrationOver">
            Registracija je uspjela. Provjeri e-mail i klikni na aktivacijski link da aktiviraš svoj račun.
          </div>
          <span class="login-wrapper">
            Imaš račun?<span class="login" v-on:click="$emit('showLoginModal')">&nbsp;Prijavi se.</span>
          </span>
        </div>
      </form>
      <img class="modal-visual" src="../../assets/visuals/phone.png" alt="Phone" />
    </div>
    <GdprModal v-if="showGdprModal" v-on:close="showGdprModal = false" />
  </div>
</template>

<script>
import { emailRegex } from '@/config';
import GdprModal from '@/components/landing-page/GdprModal.vue';

export default {
  name: 'RegistrationModal',
  data() {
    return {
      userToRegister: {},
      repeatedPassword: '',
      acceptedGdpr: false,
      showGdprModal: false,
      isFirstNameValid: true,
      isLastNameValid: true,
      isPasswordValid: true,
      isRepeatedPasswordValid: true,
      isEmailValid: true,
      doesEmailExist: false,
      didRegistrationSucceed: true,
      isRegistrationOver: false,
      isRegistering: false,
      appUrl: '',
      isSubmitted: false,
    };
  },
  components: {
    GdprModal,
  },
  methods: {
    getYears: function () {
      let currentYear = new Date().getFullYear();
      let years = [];
      let startYear = 1950;

      while (startYear <= currentYear) years.push(startYear++);

      return years.reverse();
    },
    capitalize: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    validateFirstName: function () {
      this.userToRegister.firstName = this.capitalize(this.userToRegister.firstName);
      this.isFirstNameValid = this.userToRegister.firstName ? true : false;
    },
    validateLastName: function () {
      this.userToRegister.lastName = this.capitalize(this.userToRegister.lastName);
      this.isLastNameValid = this.userToRegister.lastName ? true : false;
    },
    checkIfEmailExists: function () {
      if (!this.userToRegister.email || !emailRegex.test(this.userToRegister.email)) {
        this.doesEmailExist = false;
        this.isEmailValid = false;
      } else {
        this.isEmailValid = true;
        this.$axios
          .get(`${this.$API_URL}/user/check-email`, {
            params: {
              email: this.userToRegister.email,
            },
          })
          .then(response => {
            this.doesEmailExist = response.data;
          });
      }
    },
    validatePassword: function () {
      let pass = this.userToRegister.password;
      this.isPasswordValid = pass && pass.length >= 8 && pass.toLowerCase() !== pass && /\d/.test(pass);
    },
    validateRepeatedPassword: function () {
      this.isRepeatedPasswordValid = this.userToRegister.password === this.repeatedPassword;
    },
    isFormValid: function () {
      return (
        this.userToRegister.firstName &&
        this.userToRegister.lastName &&
        this.userToRegister.email &&
        this.userToRegister.password &&
        this.acceptedGdpr &&
        this.isFirstNameValid &&
        this.isLastNameValid &&
        this.isPasswordValid &&
        this.isRepeatedPasswordValid &&
        this.isEmailValid &&
        !this.emailExists
      );
    },
    register: function () {
      if (this.isFormValid() && this.userToRegister.password === this.repeatedPassword) {
        this.isRegistering = true;
        this.$axios
          .post(`${this.$API_URL}/user/register`, {
            userToRegister: this.userToRegister,
            appUrl: this.appUrl,
          })
          .then(() => {
            this.didRegistrationSucceed = true;
            this.isRegistering = false;
            this.isRegistrationOver = true;
            setTimeout(() => this.$emit('close'), 5000);
            window.dataLayer.push({
              event: 'register',
              email: this.userToRegister.email,
            });
          })
          .catch(() => {
            this.didRegistrationSucceed = false;
            this.isRegistering = false;
            this.isRegistrationOver = true;
            setTimeout(() => (this.isRegistrationOver = false), 5000);
          });
      } else {
        this.isSubmitted = true;
      }
    },
    getLogo: function (logoSize) {
      return require(`../../assets/logo-${logoSize
        .replace(/\s/g, '')
        .replace(/!/g, '')
        .replace(/\?/g, '')
        .replace(/\./g, '')
        .toLowerCase()}.svg`);
    },
  },
  created() {
    this.appUrl = `${window.location.protocol}//${window.location.host}`;
    this.userToRegister.birthYear = null;
    this.userToRegister.newsletterEnabled = false;
  },
  mounted() {
    document.body.classList.add('modal-open');
    document.body.classList.add('no-scroll');
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
    document.body.classList.remove('no-scroll');
  },
};
</script>

<style scoped>
.modal {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
}

.success {
  margin-bottom: 50px;
}

.modal-visual {
  width: 800px;
  height: auto;
  position: absolute;
  right: -70px;
  top: 93px;
  z-index: -1;
}

.modal-content {
  position: relative;
  margin-top: 160px;
  margin-left: 205px;
  margin-right: 137px;
}

.register-title-primary {
  color: #fff;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 48px;
  font-weight: 800;
  line-height: 58px;
  margin-bottom: 80px;
}

.close-wrapper {
  position: absolute;
  right: 0;
  top: 5px;
  display: flex;
  justify-content: flex-end;
}

.close {
  position: relative;
  top: 15px;
  cursor: pointer;
}

.close:hover .bar-1 {
  transform: translate(-1px, 8px) rotate(225deg);
}

.close:hover .bar-2 {
  transform: translate(-1px, -5px) rotate(-225deg);
}

.bar-1,
.bar-2 {
  width: 35px;
  height: 3px;
  border-radius: 1px;
  background-color: #fff;
  transition: transform 0.5s;
}

.bar-1 {
  margin-bottom: 10px;
  transform: translate(-1px, 8px) rotate(45deg);
}

.bar-2 {
  transform: translate(-1px, -5px) rotate(-45deg);
}

.error {
  margin-top: 5px;
}

#registration {
  max-width: 616px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding-bottom: 50px;
}

.login-wrapper {
  display: block;
  color: #fff;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 18px;
  line-height: 21px;
}

.login {
  color: #30cec2;
}

.terms,
.login {
  cursor: pointer;
  position: relative;
}

.terms {
  text-decoration: underline;
  color: #ffffffcc;
}

input,
select {
  width: 100%;
  border: none;
  color: #fff;
  border-bottom: 1.5px solid #fff;
  font-size: 20px;
  padding: 10px 0;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  width: 100%;
  outline: none;
  background: transparent;
  transition: border-bottom 0.2s ease-in-out;
}

select option {
  background: #0a181b;
}

.arrow-down {
  pointer-events: none;
  position: absolute;
  bottom: 15px;
  right: 10px;
}

input[type='checkbox'] {
  display: none;
}

form > div input:focus + label,
form > div > label.field-filled {
  font-size: 12px;
  top: -10px;
}

.checkbox {
  font-size: 18px;
  line-height: 21px;
  margin-bottom: 16px;
}

.checkbox:last-of-type {
  margin-bottom: 0;
}

.checkbox label {
  cursor: pointer;
  display: block;
  margin-left: 40px;
}

.checkbox label:before {
  position: absolute;
  left: 0px;
  display: inline-block;
  width: 20px;
  height: 20px;
  content: '';
  text-align: center;
  border: 2px solid #fff;
  border-radius: 4px;
}

.checkbox input:checked ~ label:before {
  content: url('../../assets/icons/check-sign.svg');
  color: #fff;
  border-color: #fff;
}

select {
  appearance: none;
  background: transparent;
  border-radius: 0;
}

form > div {
  position: relative;
}

.form-field {
  width: 288px;
  margin-bottom: 56px;
  margin-right: 40px;
}

.form-field:nth-of-type(2n) {
  margin-right: 0;
}

.form-field:nth-of-type(5),
.form-field:nth-of-type(6) {
  margin-bottom: 48px;
}

form > div.form-field > label {
  position: absolute;
  color: #ffffffcc;
  font-size: 16px;
  left: 0;
  top: 15px;
  transition: all 0.1s ease;
}

form > div.form-field input:focus + label,
form > div.form-field select + label,
form > div.form-field > label.field-filled {
  font-size: 12px;
  top: -10px;
}

form > div.form-field input:focus[type='checkbox'] + label {
  font-size: 16px;
}

.form-field--pointer > select {
  cursor: pointer;
}

input:focus,
select:focus {
  border-bottom: 1.5px solid #5ec4bc;
}

.button {
  margin-top: 80px;
  margin-bottom: 56px;
  padding: 12px 32px;
}

.spacer-top {
  margin-top: 12px;
}

.form-end {
  width: 100%;
}

.form-end label {
  color: #ffffffcc;
  display: inline-block;
}

@media screen and (max-width: 1208px) {
  .modal-visual {
    width: 400px;
    height: auto;
    top: unset;
    bottom: -360px;
    left: -75px;
  }
}

@media screen and (max-width: 1024px) {
  .modal-content {
    margin-top: 58px;
  }

  .modal-top-section {
    justify-content: space-between;
  }
}

@media screen and (max-width: 856px) {
  .form-field {
    max-width: 311px;
    margin-right: 0;
  }

  .form-field:nth-of-type(5) {
    margin-bottom: 56px;
  }

  .modal-content {
    margin-left: 32px;
    margin-right: 32px;
  }

  #registration {
    max-width: 311px;
  }

  .button {
    width: 100%;
  }
}

@media screen and (max-width: 550px) {
  .register-title-primary {
    font-size: 36px;
    line-height: 40px;
  }

  .close-wrapper {
    top: -4px;
  }

  .modal-content {
    margin-left: 32px;
    margin-right: 32px;
  }
}
</style>
